export default function Certifications() {
  const certifications = [
    {
      name: 'MSME Certification',
      description: 'Registered Micro, Small & Medium Enterprise recognized by Govt. of India',
      icon: 'ri-award-line',
      color: 'text-teal-600',
      bg: 'bg-teal-600/10',
    },
    {
      name: 'GST Registration',
      description: 'Goods & Services Tax Registered Business – Compliant with Indian Tax Authority',
      icon: 'ri-file-text-line',
      color: 'text-orange-500',
      bg: 'bg-orange-500/10',
    },
    {
      name: 'IEC Certificate',
      description: 'Import Export Code issued by DGFT – Authorized Exporter & Importer',
      icon: 'ri-ship-line',
      color: 'text-teal-600',
      bg: 'bg-teal-600/10',
    },
    {
      name: 'Export Compliance',
      description: 'Compliant with International Export Standards and Trade Regulations',
      icon: 'ri-shield-check-line',
      color: 'text-orange-500',
      bg: 'bg-orange-500/10',
    },
  ];

  return (
    <section id="certifications" className="py-12 lg:py-16 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-10">
          <p className="text-teal-600 text-xs font-semibold uppercase tracking-wider mb-4">TRUST & COMPLIANCE</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Certifications & Compliance
          </h2>
          <p className="text-lg text-gray-600">
            Recognized standards and registrations for international export
          </p>
        </div>

        {/* Certification Badges */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 text-center border border-gray-100 hover:-translate-y-1"
            >
              <div className={`w-20 h-20 mx-auto mb-5 ${cert.bg} rounded-full flex items-center justify-center`}>
                <i className={`${cert.icon} text-4xl ${cert.color}`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {cert.name}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">{cert.description}</p>
            </div>
          ))}
        </div>

        {/* Compliance Statement */}
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 bg-white px-6 py-3 rounded-full border border-gray-200">
            <i className="ri-checkbox-circle-line text-teal-600 text-xl"></i>
            <span className="text-sm text-gray-600 font-medium">Fully compliant with international export regulations & Indian trade laws</span>
          </div>
        </div>
      </div>
    </section>
  );
}
